import { colors } from "../../styles/style";

const styleButtonBlue = {
  container: {
    border: "groove 1",
    padding: 15,
    paddingTop: 2,
    paddingBottom: 2,
    borderColor: colors.BLUE_COLOR,
    backgroundColor: colors.WHITE_COLOR,
    borderRadius: 15,
    color: colors.BLUE_COLOR,
    textAlign: "center",
  },
};

const styleButtonOrange = {
  container: {
    border: 0,
    padding: 15,
    paddingTop: 2,
    paddingBottom: 2,
    backgroundColor: colors.ORANGE_COLOR,
    borderRadius: 15,
    color: colors.WHITE_COLOR,
    textAlign: "center",
  },
};

const styleButtonGray = {
  container: {
    border: "groove 1",
    padding: 15,
    paddingTop: 2,
    paddingBottom: 2,
    borderColor: colors.GRAY_4_COLOR,
    backgroundColor: colors.WHITE_COLOR,
    borderRadius: 15,
    color: colors.GRAY_2_COLOR,
    textAlign: "center",
  },
};

export { styleButtonBlue, styleButtonOrange, styleButtonGray };
